import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nationalIdValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value !== undefined && control.value) {
      var nationalId = control.value;
      switch (nationalId) {
        case '00000000000':
        case '11111111111':
        case '22222222222':
        case '33333333333':
        case '44444444444':
        case '55555555555':
        case '66666666666':
        case '77777777777':
        case '88888888888':
        case '99999999999':
          return { nationalCode: false };
      }

      if (nationalId?.length != 11) return { nationalCode: false };
      if (Number(nationalId.substr(3, 6)) == 0)
        return { nationalCode: false };

      var c = Number(nationalId.substr(10, 1));
      var d = Number(nationalId.substr(9, 1)) + 2;

      let z: Array<number>;
      z = [29, 27, 23, 19, 17];
      var s = 0;

      for (var i = 0; i < 10; i++)
        s += (d + Number(nationalId.substr(i, 1))) * z[i % 5];

      s = s % 11;

      if (s == 10) s = 0;

      if (c != s) return { nationalCode: false };
    }

    return null;
  };
}
